import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { m } from 'framer-motion';
import styled, { css } from 'styled-components';

const Wrapper = styled.section`
  background-color: ${brand.red.base};
  padding: 40px 0 30px;

  @media ${from(Device.TabletLarge)} {
    padding: 40px 0;
  }
`;

const Grid = styled.div`
  @media ${from(Device.TabletLarge)} {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 30px;
  }
`;

const Column = styled.div`
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: unset;
  }
`;

const TitleStyles = css`
  ${fonts.helvetica['73-bold-extended']};
  font-size: 12px;
  letter-spacing: ${fonts.ls(24)};
  line-height: 1.2;
  color: ${brand.white};
  text-transform: uppercase;
  padding-bottom: 6px;
  margin: 0 0 10px;
  border-bottom: 1px solid rgba(255 255 255 / 30%);
`;

const Title = styled.h2`
  ${TitleStyles};
  display: none;

  @media ${from(Device.TabletLarge)} {
    display: block;
  }
`;

const TitleAccordian = styled.h2`
  ${TitleStyles};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  cursor: pointer;

  span {
    margin-right: 14px;
  }

  @media ${from(Device.TabletLarge)} {
    display: none;
  }
`;

const Icon = styled(m.div)`
  display: inline-flex;
  align-items: center;
  width: 12px;
  height: 12px;
  transform-origin: center center;

  svg {
    width: 12px;
    height: 12px;
    color: ${brand.white};
  }
`;

const List = styled(m.ul)`
  overflow: hidden;
  padding-left: 10px;

  @media ${from(Device.TabletLarge)} {
    height: auto !important; //always visible on desktop
    padding-left: unset;
  }
`;

const Item = styled.li`
  margin-bottom: 12px;

  @media ${from(Device.TabletLarge)} {
    margin-bottom: 6px;
  }

  &:last-child {
    margin-bottom: unset;
  }
`;

const Link = styled.a`
  color: ${brand.white};
  ${fonts.helvetica['53-extended']};
  font-size: 12px;
  line-height: 1.2;
  min-height: 24px;
  display: flex;
  align-items: center;

  &:hover {
    color: ${brand.white};
    text-decoration: underline;
  }
`;

export default {
  Wrapper,
  Grid,
  Column,
  Title,
  TitleAccordian,
  Icon,
  List,
  Item,
  Link,
};
